// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import firebase from 'firebase';
import VTooltip from 'v-tooltip';
import Notify from 'vue2-notify'
import VeeValidateMessagesNL from 'vee-validate/dist/locale/nl';
import VeeValidate, { Validator } from 'vee-validate';

import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css'; // This line here

Vue.use(VueMaterial);

const Promise = require("bluebird");
// Configure
Promise.config({
    longStackTraces: true,
    warnings: true // note, run node with --trace-warnings to see full stack traces for warnings
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
'x-ticking-paragraph'
];

// Use Notify
// Default noitifications configuration: vue2-notify
Vue.use(Notify, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 3000,
    // closeButtonClass: 'close',
    position: 'bottom-right'
});

const types = {
    info: { itemClass: 'alert', iconClass: 'alert__icon mdi mdi-information'},
    error: { itemClass: 'alert--error', iconClass: 'alert__icon mdi mdi-alert-marked-circle'},
    warning: { itemClass: 'alert--warning', iconClass: 'alert__icon mdi mdi-alert'},
    success: { itemClass: 'alert--success', iconClass: 'alert__icon mdi mdi-checkbox-marked-circle'}
};
Vue.$notify.setTypes(types);

Vue.use(VTooltip);

const veeConfig = {
    errorBagName: 'errors', // change if property conflicts
    fieldsBagName: 'fields',
    delay: 0
};
Vue.use(VeeValidate, veeConfig);

/* eslint-disable no-new */
new Vue({
    el:'#app',
    router,
    template: '<App/>',
    components: { App }
});




// WEBPACK FOOTER //
// ./src/main.js